module.exports = __webpack_public_path__ + "static/bg-home-top-6d911633e382b4cb2ff042ca4b916e10.png";